import styled from 'styled-components';
import { device, hexToRGB } from '@/styles/helpers';

export const ScClaimBonusButton = styled.div`
  width: 100%;
  button {
    max-width: 280px;
    width: 100%;
    height: 48px;
    font-size: 16px;
    line-height: 18px;
  }
`;

export const ScPromoCode = styled.div`
  && .copy-code > p {
    border-color: #ffd500;
    font-size: 14px;
  }

  && button {
    background-color: #ffd500;
    border-color: #ffd500;
    color: #411a4c;
    .text {
      font-size: 14px;
    }
  }

  @media (${device.mobile}) {
    && .copy-code > p {
      font-size: 14px;
    }
    && button {
      .text {
        font-size: 14px;
      }
    }
  }

  // fr/de's longer "copy code" label doesn't fit the button's 113px
  // min-width at this size — same fix as SlotReel's ScCtaButton.
  @media (max-width: 340px) {
    && button {
      min-width: auto;
      padding: 0 8px;
      .text {
        font-size: 14px;
      }
    }
  }
`;

export const ScOfferButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  width: 100%;

  @media (${device.mobile}) {
    margin-top: 10px;
  }
`;

export const ScOfferTerms = styled.button`
  margin: 0;
  border: none;
  background: none;
  cursor: pointer;
  font-family: inherit;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.5)};
  text-align: center;
`;
